import React from 'react';
import QrCodeScanner from '@mui/icons-material/QrCodeScanner';
import Warehouse from '@mui/icons-material/Warehouse';
import ViewModule from '@mui/icons-material/ViewModule';
import LocalShipping from '@mui/icons-material/LocalShipping';
import Inventory from '@mui/icons-material/Inventory';
import Assignment from '@mui/icons-material/Assignment';

import IntakeScreen from './IntakeScreen';
import PutawayScreen from './PutawayScreen';
import StagingScreen from './StagingScreen';
import LoadingScreen from './LoadingScreen';
import StockDashboard from './StockDashboard';
import DespatchDashboard from './DespatchDashboard';

export interface WmsRoute {
  /** Router path */
  path: string;
  /** Short label for the sidebar nav item */
  label: string;
  /** Page title shown in the layout app bar */
  title: string;
  /** Icon rendered in the sidebar */
  icon: React.ReactNode;
  /** Route element */
  element: React.ReactNode;
}

/**
 * Single source of truth for WMS routes, nav items, and page titles.
 *
 * Consumed by both App.tsx (route definitions) and WmsLayout (sidebar + title bar).
 * Container Management routes are intentionally excluded — this array is WMS-only.
 */
export const wmsRoutes: WmsRoute[] = [
  {
    path: '/wms/intake',
    label: 'Intake',
    title: 'Pallet Intake',
    icon: <QrCodeScanner />,
    element: <IntakeScreen />,
  },
  {
    path: '/wms/putaway',
    label: 'Putaway',
    title: 'VNA Putaway',
    icon: <Warehouse />,
    element: <PutawayScreen />,
  },
  {
    path: '/wms/staging',
    label: 'Staging',
    title: 'Staging',
    icon: <ViewModule />,
    element: <StagingScreen />,
  },
  {
    path: '/wms/loading',
    label: 'Loading',
    title: 'Loading',
    icon: <LocalShipping />,
    element: <LoadingScreen />,
  },
  {
    path: '/wms/stock',
    label: 'Stock',
    title: 'Stock Visibility',
    icon: <Inventory />,
    element: <StockDashboard />,
  },
  {
    path: '/wms/despatch',
    label: 'Despatch',
    title: 'Despatch Office',
    icon: <Assignment />,
    element: <DespatchDashboard />,
  },
];
